import { useState } from 'react';

export default function JobsPage() {
  const [notified, setNotified] = useState(false);
  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '24px 0', minHeight: 'calc(100vh - 60px)', textAlign: 'center' }}>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 28, fontWeight: 700, margin: '0 0 8px', color: 'var(--text)' }}>
          Job Board
        </h1>
        <p style={{ fontSize: 15, color: 'var(--text2)', margin: 0 }}>
          Curated openings at top Indian tech companies
        </p>
      </div>

      <div style={{ marginTop: 60, padding: 40, border: '1px dashed var(--border)', borderRadius: 24, background: 'var(--surface)' }}>
         <div style={{ fontSize: 48, marginBottom: 20 }}>🚀</div>
         <h2 style={{ fontFamily: 'var(--display)', fontSize: 24, fontWeight: 800, color: 'var(--text)', marginBottom: 12 }}>Coming Soon</h2>
         <p style={{ fontSize: 14, color: 'var(--text2)', maxWidth: 400, margin: '0 auto 24px', lineHeight: 1.6 }}>
           Our verified job board is under active development. We'll soon bring you direct openings from companies with the best interview cultures.
         </p>
         <button onClick={() => setNotified(true)} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 20px', background: 'var(--blue)', color: '#fff', borderRadius: 10, fontSize: 13, fontWeight: 700, border: 'none', cursor: notified ? 'default' : 'pointer' }}>
           {notified && (
             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
               <polyline points="20 6 9 17 4 12" />
             </svg>
           )}
           {notified ? "You'll get notified" : 'Get Notified'}
         </button>
      </div>
    </div>
  );
}
